import { enumToOptions } from '@libs/types/src/common/enum/util';

export enum SocialServiceFacultativeCodeEnum {
    TRANSPORTATION = 'transportation',
    LEISURE_ACTIVITIES = 'leisureActivities',
    INTEREST_ACTIVITIES = 'interestActivities',
    SCHOOL_DISCUSSION = 'schoolDiscussion',
    COMPUTER = 'computer',
    HYGIENE_SUPPLY = 'hygieneSupply',
    RENTAL_EQ = 'rentalEq',
    JOB_COUNSEL = 'jobCounsel',
    CHILD_TUTOR = 'childTutor',
    FOOD_ASSIST = 'foodAssist',
    CLOTHING = 'clothing',
    HOUSEHOLD_EQ_RENTAL = 'householdEqRental',
    MED_TESTING = 'medTesting',
    INJECTION_EQ = 'injectionEq',
    LAUNDRY = 'laundry',
    PSYCHOTHERAPY = 'psychotherapy',
    LECTURES = 'lectures',
    PHYSIOTHERAPY = 'physiotherapy',
    COURSES = 'courses',
    MED_TREATMENT_SUPPORT = 'medTreatmentSupport',
    EMERGENCY_VISIT = 'emergencyVisit',
    MASSAGES = 'massages',
    PEDICURES = 'pedicures',
    AID_EQ_LOAN = 'aidEqLoan',
    TEXT_DIGI = 'textDigi',
    RADIO = 'radio',
    TV_RENT = 'tvRent',
    BARBER = 'barber',
    SHOPPING = 'shopping',
    HIPPOTHERAPY = 'hippotherapy',
    HYDROTHERAPY = 'hydrotherapy',
}

export const socialServiceFacultativeCodeEnumOptions = enumToOptions(SocialServiceFacultativeCodeEnum, 'serviceType.operation.facultativeCode.');
